module.exports = __webpack_public_path__ + "static/media/bg-music-loop.590a5971.mp3";